module.exports = __webpack_public_path__ + "static/media/tstm-walkyria.acc1e307.png";